import {z} from '@hono/zod-openapi';

import {advertisementPayloadSchema} from './AdvertisementPayloadSchema';
import {
  advertisingCredentialsSchema,
  advertisingImageSchema,
  advertisingPlatformCodeSchema,
} from './AdvertisingCommonSchemas';

const MAX_ITEMS = 20;

const advertisingPreflightItemSchema = z.object({
  platformCode: advertisingPlatformCodeSchema,
  publishingBranchId: z.string().uuid().nullable(),
  vehicle: advertisementPayloadSchema,
  credentials: advertisingCredentialsSchema.nullable(),
  images: z.array(advertisingImageSchema).default([]),
});

export const advertisingPreflightRequestSchema = z
  .object({
    tenantId: z.string().uuid(),
    vehicleId: z.string().uuid(),
    items: z.array(advertisingPreflightItemSchema).min(1).max(MAX_ITEMS),
  })
  .openapi('AdvertisingPreflightRequest');

export type AdvertisingPreflightRequest = z.infer<typeof advertisingPreflightRequestSchema>;
